<template>
<div>
    <h3 class="font-weight-regular mb-4 submenu-title">{{$t('bodenanschluss')}}</h3>
    <v-row>
        <v-col md="6" sm="12">
            <div class="subtitle-2 mb-2">{{$t('staffelOberflache')}}</div>
            <!-- {{getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_OBERFLAECHE', doorLeafSurfaceContext)}} -->
            <v-select
                    dense
                    v-if="!isMassivholzstaffel() && !isStantardStaffel()"
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="getCharacteristicAndValues('KTU_MM_STAFFEL_OBERFLAECHE').values" item-text="description"
                    :value="getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_OBERFLAECHE', doorLeafSurfaceContext).value"
                    @change="handleSurfaceOptionSelect($event);">
            </v-select>
            <v-select
                    dense
                    v-if="isStantardStaffel()"
                    outlined
                    return-object
                    :menu-props="{ offsetY: true }"
                    :items="getCharacteristicAndValues('CUST_MM_STAFFEL_OBERFLAECHE').values" item-text="description"
                    :value="getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_OBERFLAECHE', doorLeafSurfaceContext).value"
                    @change="handleSurfaceStandardOptionSelect($event);">
            </v-select>
            <v-select
                    v-if="isMassivholzstaffel()"
                    dense
                    outlined
                    return-object
                    :menu-props="{ offsetY: true }"
                    :items="getCharacteristicAndValues('CUST_MM_STAFFEL_FORM_OBF').values" item-text="description"
                    :value="getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_FORM_OBF', doorLeafSurfaceContext).value"
                    @change="handleStaffelSelect($event);">
            </v-select>
        </v-col>
    </v-row>
    <v-row>
        <v-col md="6" sm="12" class="py-0">
            <div class="body-2 pb-2" style="">{{$t('sonderDekorLackierung')}}</div>
            <v-text-field  class="mb-5" v-model="specialDecor"  :disabled="!inputEnabled" dense outlined hide-details >
            </v-text-field>
        </v-col>
    </v-row>
    <v-row>
        <v-col md="6" sm="12" class="py-0">
            <div class="subtitle-2 mb-2">{{$t('trittwinkelStaffel')}}</div>
            <v-select 
                    dense 
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="getCharacteristicAndValues('KTU_MM_STAFFEL_FARBE').values" item-text="description"
                    :value="getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_FARBE', doorLeafSurfaceContext).value"
                    @change="handleTreadAngleSurfaceOptionSelect($event);this.filterDependencies('KTU_MM_STAFFEL_FARBE');">
            </v-select>
        </v-col>
    </v-row>
</div>
    <!-- <div>                            
        <h1 class="title">Bodenanschluss</h1>
            <div class="zarge-wrap">
            <label class="input-label">Staffel Oberfläche</label>
                <div class="full-dropdown">
                <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle dropdown-button"
                            type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue("KTU_MM_STAFFEL_OBERFLAECHE", doorLeafSurfaceContext).value.description }}<span></span>
                        </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <div class="simplebar" data-simplebar>
                            <div>
                        <a v-for="(valueDefinition, index) in getCharacteristicAndValues('KTU_MM_STAFFEL_OBERFLAECHE').values" :key="index"
                                @click.prevent="handleSurfaceOptionSelect(valueDefinition);" 
                                class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

                <div :class="{'input-group' : true, 'disabled' : !inputEnabled}">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing-default">Sonder Dekor / Lackierung-RAL Farbe </span>
                    </div>
                    <input type="text" class="form-control" v-model="specialDecor" aria-label="Default" :disabled="!inputEnabled"
                        aria-describedby="inputGroup-sizing-default" value="">
                </div>
              
                <label class="input-label">Trittwinkel fur den Staffel</label>
                <div class="full-dropdown">
                    <div class="dropdown">
                        <button class="btn btn-secondary dropdown-toggle dropdown-button"
                                type="button" id="dropdownMenuButton" data-toggle="dropdown"
                                aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue("CUST_MM_STAFFEL_FORM_OBF", doorLeafSurfaceContext).value.description }}<span></span>
                            </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <div class="simplebar" data-simplebar>
                            <div>
                            <a v-for="(valueDefinition, index) in getCharacteristicAndValues('CUST_MM_STAFFEL_FORM_OBF').values" :key="index"
                                    @click.prevent="handleTreadAngleSurfaceOptionSelect(valueDefinition);" 
                                    class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</template>
<script>
    import Vue from 'vue';  
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';       
    import { DoorConfiguration } from '../../../configurator/DoorConfiguration';

    export default Vue.extend({
        name: 'FloorConnection',        
        props: {
            characteristic: Object,            
        },
        data() {
            return {
                doorLeafSurfaceContext : DoorConfiguration.DoorLeafSurface,
                specialCharacteristicLLTNumber : "LLT120060",
                inputEnabled : false,
                specialDecorValue : '',
            }
        },
        computed: {            
             ...mapGetters('configuratorModule',['getCurrentDoorConfiguration','getRegisteredCharacteristicsValue','getBlankCharacteristic']),
             ...mapGetters('doorLeafSurfaceModule', [ 'getCharacteristicAndValues', 'getNrOfValuesByCharacteristic', 'checkRadioValue', 'getOberflacheValue' ]),

             specialDecor : {
                 //getter
                get: function () {
                    if(parseInt(this.getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_O_SO', this.doorLeafSurfaceContext).value.value) == 0)
                    {
                        this.specialDecorValue = '';
                    }else {
                        this.specialDecorValue = this.getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_O_SO', this.doorLeafSurfaceContext).value.value;
                    }
                    
                    return this.specialDecorValue;
                },
                //setter
                set : function(newValue) {
                    this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_STAFFEL_O_SO'), value: newValue });
                    this.specialDecorValue = newValue;
                }
            },
        },
        methods: {
             ...mapActions('configuratorModule',['updateDoorConfiguration']),
            ...mapActions('doorLeafSurfaceModule', ['addCharacterisitc','valueAddCharacteristic']),
            handleSurfaceOptionSelect(valueDefinition){
                // this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('CUST_MM_STAFFEL_OBERFLAECHE'), valueDefinition: valueDefinition });
                // let optionValue = this.getOberflacheValue(valueDefinition.value)
                 this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("KTU_MM_STAFFEL_OBERFLAECHE"), valueDefinition: valueDefinition });
                 if(valueDefinition.value === this.specialCharacteristicLLTNumber){
                     this.inputEnabled = true;
                 }else {
                     this.inputEnabled = false;
                     this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_STAFFEL_O_SO'), value: 0 });

                 }
                 this.filterDependencies('KTU_MM_STAFFEL');
            },
            handleSurfaceStandardOptionSelect(valueDefinition){
                this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues('CUST_MM_STAFFEL_OBERFLAECHE'), valueDefinition: valueDefinition });
                let optionValue = this.getOberflacheValue(valueDefinition.value)
                this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("KTU_MM_STAFFEL_OBERFLAECHE"), valueDefinition: optionValue })
                if(optionValue.value === this.specialCharacteristicLLTNumber){
                    this.inputEnabled = true;
                }else {
                    this.inputEnabled = false;
                    this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_STAFFEL_O_SO'), value: 0 });
                }
                this.filterDependencies('KTU_MM_STAFFEL');
            },
            handleStaffelSelect(event) {
                this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("CUST_MM_STAFFEL_FORM_OBF"), valueDefinition: event });
                let staffelValues = this.getCharacteristicAndValues('KTU_MM_STAFFEL').values;
                if(event.value === 'BUCHE') {
                    let valueToSet = staffelValues.find(x => x.value === 'LLT100104');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("KTU_MM_STAFFEL"), valueDefinition: valueToSet });
                }
                else if(event.value === 'EICHE') {
                    let valueToSet = staffelValues.find(x => x.value === 'LLT100103');
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("KTU_MM_STAFFEL"), valueDefinition: valueToSet });
                }

            },
            isMassivholzstaffel: function() {
                let staffelFormValue = this.getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_FORM', DoorConfiguration.Measure).value.value;
                return staffelFormValue === "HS";
            },
            isStantardStaffel: function() {
                let staffelFormValue = this.getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_FORM', DoorConfiguration.Measure).value.value;
                return staffelFormValue === "STD";
            },
            // sortValues(data) {
            //     var filteredData = [];
            //     data.map(function(item, index) {
            //         if(item['value'] === 'LLT120060') {
            //             filteredData.push({
            //             index: data.length+1,
            //             id : item['id'],
            //             value: item['value'],
            //             description: item['description'],
            //             resource: item['resource'],
            //             default: item['default']});
            //         } else {
            //            filteredData.push({
            //             index: index,
            //             id : item['id'],
            //             value: item['value'],
            //             description: item['description'],
            //             resource: item['resource'],
            //             default: item['default']});
            //         }
            //
            //     })
            //     return filteredData.sort((a,b) => a.index - b.index);
            // },
            handleTreadAngleSurfaceOptionSelect(valueDefinition){
                this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("KTU_MM_STAFFEL_FARBE"), valueDefinition: valueDefinition });
            },
            filterDependencies(characteristicCode) {
                 this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', characteristicCode);
            },
        }, 
        mounted() {
            let staffelValue = this.getRegisteredCharacteristicsValue('KTU_MM_STAFFEL_OBERFLAECHE', this.doorLeafSurfaceContext).value.value;
            let staffelCustValue = this.getRegisteredCharacteristicsValue('CUST_MM_STAFFEL_OBERFLAECHE', this.doorLeafSurfaceContext).value.value;

            if(staffelValue === this.specialCharacteristicLLTNumber && staffelCustValue === '13'){
                this.inputEnabled = true;
            }
            else {
                this.inputEnabled = false;
                this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_STAFFEL_O_SO'), value: 0 });
            }

            //  this.filterDependencies('KTU_MM_STAFFEL_OBERFLAECHE');
            //  this.filterDependencies('KTU_MM_STAFFEL');
            this.filterDependencies('CUST_MM_STAFFEL_FORM_OBF');
        },
    })
</script>